import React from 'react';
import { Button } from '../common/Button';
import useI18n from '../../hooks/useI18n';

interface FileInfoProps {
  file: File;
  onRemoveFile: () => void;
  onUpload: () => void;
}

const FileInfo: React.FC<FileInfoProps> = ({
  file,
  onRemoveFile,
  onUpload,
}) => {
  const { t, formatNumber } = useI18n();

  return (
    <div className="flex flex-col items-center justify-center h-64 lg:h-72">
      <img
        src="/assets/fileIcon.svg"
        alt={String(t('bulkUpload.fileIcon'))}
        className="w-12 h-12 mb-4"
      />
      <div className="flex flex-col lg:flex-row items-center justify-center">
        <p className="text-gray-500 text-center mr-2 lg:mr-4 whitespace-nowrap">
          {t('bulkUpload.selectedFile')}
        </p>
        <p className="text-gray-700 text-center font-semibold mr-2 lg:mr-4 whitespace-nowrap">
          {file.name}
        </p>
        <p className="text-sm text-gray-400 text-center mr-2 lg:mr-4 whitespace-nowrap">
          {formatNumber(file.size / (1024 * 1024), {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })}{' '}
          {t('common.mb')}
        </p>
        <button
          className="text-gray-500 hover:text-gray-700"
          onClick={onRemoveFile}
          aria-label={String(t('common.remove'))}
        >
          &times;
        </button>
      </div>
      <Button onClick={onUpload} className="mt-6">
        {t('common.upload')}
      </Button>
    </div>
  );
};

export default FileInfo;
